import { useEffect, useState } from "react";
import {
  Badge,
  Button,
  ButtonGroup,
  Card,
  Col,
  Container,
  ProgressBar,
  Row,
  Spinner,
  Table,
} from "react-bootstrap";
import { Redirect } from "react-router-dom";
import SidebarPanelNavigation from "../../../../components/SidebarPanelNavigation";
import useAuth from "../../../../contexts/auth";
import { getWhatsAppWebStatistics } from "../../../../services/api";

export default function StatisticsPage() {
  const { user } = useAuth();
  const [days, setDays] = useState(30);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    getWhatsAppWebStatistics(days)
      .then((r) => setData(r?.data || null))
      .finally(() => setLoading(false));
  }, [days]);

  if (!user) return <Redirect to="/entrar" />;
  if (user.type !== "admin") return <Redirect to="/" />;

  const totalMsg = data?.messages?.total || 0;
  const sent = data?.messages?.sent || 0;
  const failed = data?.messages?.failed || 0;
  const successRate = totalMsg > 0 ? ((sent / totalMsg) * 100).toFixed(1) : 0;
  const errorRate = totalMsg > 0 ? ((failed / totalMsg) * 100).toFixed(1) : 0;

  return (
    <Container fluid className="p-4">
      <Row>
        <Col md={3} lg={2}>
          <SidebarPanelNavigation isAdmin />
        </Col>
        <Col md={9} lg={10}>
          <div className="d-flex justify-content-between mb-3">
            <div>
              <h2 className="mb-1">📊 Estatísticas</h2>
              <p className="text-muted">Métricas de WhatsApp Web</p>
            </div>
            <ButtonGroup>
              {[7, 30, 90].map((d) => (
                <Button
                  key={d}
                  variant={days === d ? "primary" : "outline-primary"}
                  onClick={() => setDays(d)}
                >
                  {d} dias
                </Button>
              ))}
            </ButtonGroup>
          </div>

          {loading ? (
            <div className="text-center p-5">
              <Spinner animation="border" />
            </div>
          ) : (
            data && (
              <>
                <Row>
                  <Col md={3}>
                    <Card>
                      <Card.Body>
                        <small className="text-muted">Campanhas</small>
                        <h2 className="text-primary">
                          {data.campaigns.total}
                        </h2>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col md={3}>
                    <Card>
                      <Card.Body>
                        <small className="text-muted">Mensagens</small>
                        <h2 className="text-info">{totalMsg}</h2>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col md={3}>
                    <Card>
                      <Card.Body>
                        <small className="text-muted">Enviadas</small>
                        <h2 className="text-success">{sent}</h2>
                        <small className="text-success">
                          {successRate}% sucesso
                        </small>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col md={3}>
                    <Card>
                      <Card.Body>
                        <small className="text-muted">Erros</small>
                        <h2 className="text-danger">{failed}</h2>
                        <small className="text-danger">
                          {errorRate}% erro
                        </small>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>

                <Card className="mb-3 mt-2">
                  <Card.Body>
                    <strong>Taxa de Sucesso</strong>
                    <ProgressBar
                      className="mt-2"
                      now={parseFloat(successRate)}
                      label={`${successRate}%`}
                      variant="success"
                    />
                  </Card.Body>
                </Card>

                <Card className="mb-3">
                  <Card.Body>
                    <h5>Canais</h5>
                    <p className="mb-0">
                      <Badge variant="success">
                        {data.channels.active} ativos
                      </Badge>{" "}
                      / {data.channels.total} total
                    </p>
                  </Card.Body>
                </Card>

                <Card>
                  <Card.Body>
                    <h5>Desempenho por Canal</h5>
                    {(data.by_channel || []).length === 0 ? (
                      <p className="text-muted mb-0">
                        Nenhum dispatch no período.
                      </p>
                    ) : (
                      <Table responsive striped size="sm">
                        <thead>
                          <tr>
                            <th>Canal</th>
                            <th>Total</th>
                            <th>Enviadas</th>
                            <th>Falhas</th>
                            <th>Taxa</th>
                          </tr>
                        </thead>
                        <tbody>
                          {(data.by_channel || []).map((c) => {
                            const rate =
                              c.total > 0
                                ? ((c.sent / c.total) * 100).toFixed(1)
                                : 0;
                            return (
                              <tr key={c.id}>
                                <td>{c.name}</td>
                                <td>{c.total}</td>
                                <td className="text-success">{c.sent}</td>
                                <td className="text-danger">{c.failed}</td>
                                <td>
                                  <Badge
                                    variant={
                                      rate >= 80 ? "success" : "warning"
                                    }
                                  >
                                    {rate}%
                                  </Badge>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                    )}
                  </Card.Body>
                </Card>
              </>
            )
          )}
        </Col>
      </Row>
    </Container>
  );
}
